export default {
    getPlayerData(state) {
        return state.selectedplayerData;
      },
    getSelectedPlayer(state){
      return state.selectedGamer;
    },
    getMySalary(state){
      return state.mySalary;
    }
}